export const DYNAMIC_ATTRIBUTES_LIMIT = 100;
